// extracted by mini-css-extract-plugin
export default {"container":"error_container__5n5ZE","wrapper":"error_wrapper__AAhCz","text":"error_text__WgEXl","title":"error_title__TAMOu","link":"error_link__r-J5q"};